import { TaskPropApi } from "../ServerResponseType/Task/Task";

export interface TaskRequestApi extends TaskPropApi {
  taskContent: string;
  taskTagIds: string[];
}

export class TaskRequestImpl implements TaskRequestApi {
  taskPrivateName: string;
  taskPublicName: string;
  taskStatusId: number;
  taskContent: string;
  taskCost: number;
  taskId?: string;
  taskTagIds: string[];
  taskModificationTime: Date;
  taskCreationTime: Date;

  constructor(taskData: TaskRequestApi) {
    this.taskPrivateName = taskData.taskPrivateName;
    this.taskPublicName = taskData.taskPublicName;
    this.taskStatusId = taskData.taskStatusId;
    this.taskContent = taskData.taskContent;
    this.taskCost = taskData.taskCost;
    this.taskId = taskData.taskId;
    this.taskTagIds = taskData.taskTagIds;
    this.taskCreationTime = taskData.taskCreationTime;
    this.taskModificationTime = taskData.taskModificationTime;
  }
}
